import { List, ListItem, ListItemText, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AppMobileSignedUser({ userName, coName, logout }) {
  const isSignedIn = userName !== "";
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      {!isSignedIn ? (
        <Box
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#005078",
            padding: "5px",
            marginLeft: "20px"
          }}
          onClick={() => navigate(`/${i18n.language}/seller-profile`)}
        >
          {t('appMobileSignedUser.signIn')}
        </Box>
      ) : (
        <List sx={{ paddingLeft: "5px", marginLeft: "20px" }}>
          <Typography sx={{
            fontSize: "16px",
            fontWeight: 400, marginBottom: "15px"
          }}>
            {userName}
          </Typography>
          <ListItem disablePadding>
            <ListItemText
              primary={
                t('appMobileSignedUser.viewProfile', { coName })}
              style={{
                color: "#005078",
              }}
              onClick={() => navigate(`/${i18n.language}/seller-profile`)}
            />
          </ListItem>
          <ListItem disablePadding>
            <ListItemText
              primary={t('appMobileSignedUser.signOut')}
              onClick={() => logout()}
              style={{
                color: "#005078",
              }}
            />
          </ListItem>
        </List>
      )}
    </>
  );
}
